<template>
  <div v-if="productsOriginal && productsOriginal.length">
    <div class="vx-row">
      <div
        class="vx-col w-full md:w-1/4 mb-base"
        v-for="prd in filteredProducts"
        :key="prd.id"
      >
        <vx-card :title="`${prd.title} - ${formatPrice(prd.cost)}`">
          <p>Quantity</p>
          <div class="flex">
            <vs-input-number
              size="large"
              min="0"
              max="10000"
              v-model="prd.qty"
            />
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="Cart Summary">
          <ul>
            <li
              v-for="item in orderedProducts"
              :key="item.id"
              class="font-semibold text-primary"
            >
              {{ item.qty }} x {{ item.title }}
            </li>
            <li
              v-if="orderedProducts.length === 0"
              class="mt-3 font-semibold text-danger"
            >
              You have no products added to cart
            </li>

            <div class="mt-4" style="max-width: 200px">
              <vs-select
                v-model="fund.type"
                class="w-full select-large mb-4"
                label="Payment Type"
                placeholder="Select Payment Type"
              >
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.label"
                  v-for="item in types"
                  class="w-full"
                />
              </vs-select>
            </div>

            <div
              class="mt-4 mb-4"
              style="
                max-width: 300px;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
              "
            >
              <vs-input
                label="Promo Code"
                v-model="appliedPromoCode"
                class="w-full"
                oninput="this.value = this.value.toUpperCase()"
              />
              <vs-button
                class="ml-5"
                @click.native="verifiedPromoCode"
                style="display: flex; justify-content: center"
                >Apply</vs-button
              >
            </div>
            <div v-if="discountAmount">
              <li v-if="fund.type === 'cc'" class="mt-3">
                Discount: {{ formatPrice(discountAmount) }}
              </li>
              <li v-else class="mt-3">
                Discount: {{ formatPrice(discountAmount) }}
              </li>
            </div>
            <small
              class="mt-4 vs-input--label text-danger pl-0"
              v-if="fund.type === 'cc' && orderedProducts.length !== 0"
              >For Credit card payments, there will be a ${{
                ccTotal.fee
              }}
              fee.</small
            >
            <li v-if="fund.type === 'cc'" class="mt-6">
              Sub Total: {{ formatPrice(ccTotal.subTotal) }}
            </li>

            <li v-else class="mt-6">Sub Total: {{ formatPrice(newSub) }}</li>

            <li v-if="fund.type === 'cc'" class="mt-3">
              Tax: {{ formatPrice(ccTotal.tax) }}
            </li>
            <li v-else class="mt-3">Tax: {{ formatPrice(tax) }}</li>
          </ul>

          <!-- <credit-card-field v-if="fund.type === 'cc'"> </credit-card-field> -->

          <div class="flex flex-col mt-4">
            <label class="vs-input--label pl-0">Final Amount in $CAD</label>

            <div class="flex text-xl text-success" v-if="fund.type === 'cc'">
              <strong>{{ formatPrice(ccTotal.newTotal) }}</strong>
            </div>
            <div class="flex text-xl text-success" v-else>
              <strong>{{ formatPrice(total) }}</strong>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="CC Details" v-if="fund.type === 'cc'">
          <vs-input label="Cardholder Name" class="w-full" v-model="cc.name" />

          <div class="vs-con-input mt-4 w-full">
            <label class="vs-input--label block">Credit Card Number</label>
            <TheMask
              v-model="cc.num"
              :mask="['#### ###### #####', '#### #### #### ####']"
              class="vs-inputx vs-input--input normal"
            />
          </div>

          <div class="flex mt-4" style="gap: 1ch">
            <div class="vs-con-input">
              <vs-select
                v-model="cc.expMM"
                class="w-full select-large mb-4"
                label="Expiry Month"
                placeholder="MM"
              >
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.label"
                  v-for="item in months"
                  class="w-full"
                />
              </vs-select>
            </div>
            <div class="vs-con-input">
              <vs-select
                v-model="cc.expYY"
                class="w-full select-large mb-4"
                label="Expiry Year"
                placeholder="YYYY"
              >
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.label"
                  v-for="item in years"
                  class="w-full"
                />
              </vs-select>
            </div>
          </div>

          <div class="vs-con-input">
            <label class="vs-input--label block">CVV</label>
            <TheMask
              v-model="cc.cvv"
              :mask="['###', '####']"
              class="vs-inputx vs-input--input normal"
              style="width: 10ch"
            />
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col">
        <vs-button @click="request">Submit</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
// import { InlineCreditCardField } from 'vue-credit-card-field';
import { TheMask } from "vue-the-mask";
import { formatPrice, $loading, notify } from "@/assets/helper";

export default {
  components: { TheMask },
  data: () => ({
    products: [],
    ccProcessing: 3.28,
    cc: {
      num: "",
      expMM: "",
      expYY: "",
      cvv: "",
      name: "",
    },
    fund: {
      account: "",
      type: "cheque",
    },
    types: [
      { label: "EFT", value: "eft" },
      { label: "Cheque", value: "cheque" },
      { label: "Credit Card", value: "cc" },
    ],
    months: [
      { label: "01", value: "01" },
      { label: "02", value: "02" },
      { label: "03", value: "03" },
      { label: "04", value: "04" },
      { label: "05", value: "05" },
      { label: "06", value: "06" },
      { label: "07", value: "07" },
      { label: "08", value: "08" },
      { label: "09", value: "09" },
      { label: "10", value: "10" },
      { label: "11", value: "11" },
      { label: "12", value: "12" },
    ],
    years: [],
    appliedPromoCode: null,
    discountAmount: "",
    discountInfo: {},
  }),
  watch: {
    "cc.name"(val) {
      if (val === "devisa") {
        this.cc.num = "4263970000005262";
        this.cc.name = "Test Tester";
        this.cc.cvv = "333";
        this.cc.expMM = "05";
        this.cc.expYY = "23";
      }
    },
    amount(val) {
      this.fund = {
          ...this.fund,
          ...val
      }
    },
    subTotal(val) {
      this.calculateDiscount();
    },
    appliedPromoCode(val) {
      if (!val) {
        this.resetCC();
      }
    },
  },
  computed: {
    filteredProducts() {
      return this.products.filter((x) => x.active);
    },
    orderedProducts() {
      return this.products
        .filter((x) => x.qty > 0)
        .map((item) => {
          item.subTotal = item.cost * item.qty;
          return item;
        });
    },
    subTotal() {
      let sum = 0;
      this.orderedProducts.forEach(({ subTotal = 0 }) => {
        sum += subTotal;
      });



      return +parseFloat(sum.toFixed(2));
    },
    ccTotal() {
      if (this.fund.type !== "cc") return {};
      let fee = this.ccFee;
      console.log(fee);
      let subTotal = +(this.subTotal - this.discountAmount + fee).toFixed(2); //

      let tax = +(subTotal * 0.13).toFixed(2);

      let newTotal = +(subTotal + tax).toFixed(2);
      // newTotal = Math.ceil(newTotal);
      console.log(tax);
      return {
        newTotal,
        subTotal,
        fee,
        tax,
      };
    },
    // discount() {
    //   return this.calculateDiscount();

    //   // return 0;
    // },
    newSub() {
      let sub = this.subTotal;
      let discount = 0;
      if (sub > 0) {
        discount = this.discountAmount;
      }

      let newSub = sub - discount;
      console.log(newSub);
      return +parseFloat(newSub.toFixed(2));
    },
    ccFee() {
      let ccFeePercentage = this.ccProcessing / 100;
      console.log(ccFeePercentage);
      return +(this.newSub * ccFeePercentage).toFixed(2);
    },

    tax() {
      if (this.fund.type == "cc") {
        return parseFloat(((this.newSub + this.ccFee) * 0.13).toFixed(2));
      } else {
        return parseFloat((this.newSub * 0.13).toFixed(2));
      }
    },

    total() {
      let totalSofar = this.tax + this.newSub;
      return parseFloat(totalSofar.toFixed(2));
    },
    account() {
      return this.$store.state.currentAccount;
    },
    productsOriginal() {
      return Object.values(this.$store.state.products);
    },
    product() {
      let product = this.fund.product;
      if (!product) return {};
      return this.products[product] || {};
    },
    amountToString() {
      let { total } = this.amount;
      return (
        "$" +
        total.toLocaleString("US", {
          minimumFractionDigits: 2,
        })
      );
    },
    sendObj() {
      let obj = {
        ...this.fund,
        orderItems: this.orderedProducts.map((x) => ({
          id: x.id,
          quantity: x.qty,
        })),
        subTotal: this.newSub,
        discount: this.discountAmount,
        tax: this.tax,
        total: this.total,
        promoCode: this.discountInfo.code,
      };
      if (this.fund.type === "cc") {
        obj.cc = this.cc;
        (obj.fee = this.ccTotal.fee),
          (obj.total = this.ccTotal.newTotal),
          (obj.subTotal = this.ccTotal.subTotal),
          (obj.tax = this.ccTotal.tax);
      }
      return obj;
    },
  },
  methods: {
    formatPrice,
    resetCC() {
      // this.ccFee = 0;
      // this.subTotal = 0;
      this.discountAmount = 0;
    },
    goAway() {
      this.$router.push("/my-transactions");
    },
    async verifiedPromoCode() {
      try {
        let { data } = await this.$get(
          `/promo-codes/verify/${this.appliedPromoCode}`
        );
        this.discountInfo = data;
        this.calculateDiscount();
      } catch (e) {
        console.log(e);
      }
    },
    calculateDiscount() {
      if (!this.appliedPromoCode || this.orderedProducts.length <= 0) {
        return (this.discountAmount = 0);
      }

      let {
        minPurchase,
        id,
        value,
        type,
        code,
        description = "",
      } = this.discountInfo;

      console.log(this.subTotal);
      console.log(minPurchase);
      if (this.subTotal < minPurchase) {
        notify({
          title: "Error",
          text: "Sorry, under minimum purchase value",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "bottom-right",
        });
        return 0;
      }

      if (type === "percentage") {
        console.log("tttttt");
        let fraction = value / 100;
        this.discountAmount = fraction * this.subTotal;
      } else {
        this.discountAmount = value;
      }
      console.log("ddddsssss", this.discountAmount);

      this.discountAmount = +parseFloat(this.discountAmount.toFixed(2));

      return this.discountAmount;
    },
    confirmed() {
      let sendObj = this.sendObj;

      $loading();

      this.$api
        .post(`/ticket-orders/`, sendObj)
        .then(({ data }) => {
          console.log("DATAAAAAAAA", data);
          let { product = {}, qty = 1 } = data;
          let text = `You have successfully made an order. `;

          if (data.status === "partial") {
            text += ` We have partially released some Tickets in advanced. We thank you for your continued business.`;
          } else if (data.status === "complete") {
            text = `You have successfully added Tickets to your account. We thank you for your continued business.`;
          } else if (data.status === "pending") {
            text +=
              "Once your payment is verified, your credits will be released!";
          }

          this.$vs.dialog({
            color: `success`,
            title: `Ticket Invoice#: ${data.uid}`,
            text,
            accept: this.goAway,
          });
        })
        .catch((err) => {
          this.$vs.dialog({
            color: `danger`,
            title: `Uh oh,`,
            text: "An error occurred while processing your order. Please try again.",
          });
        })
        .finally(() => {
          $loading.close();
        });
    },
    errorMsg(text) {
      this.$vs.dialog({
        color: "danger",
        title: `Error`,
        text,
      });
    },
    request() {
      if (!this.orderedProducts.length)
        return this.errorMsg("Please choose a product");

      if (this.fund.type === "cc") {
        if (!this.cc.num.trim())
          return this.errorMsg("Please enter Credit Card number");
        if (
          !this.cc.name.trim() ||
          !this.cc.cvv.trim() ||
          !this.cc.expMM ||
          !this.cc.expYY
        )
          return this.errorMsg("Please enter credit card information");
      }

      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Confirm Fund Request`,
        text: `You are about to request ticket(s) for the final amount of ${formatPrice(
          this.sendObj.total
        )} CAD`,
        accept: this.confirmed,
      });
    },
  },
  created() {
    console.log(process.env.VUE_APP_API);
    if (this.account && this.account.id) this.fund.account = this.account.id;
    let years = [];
    let year = new Date().getFullYear();
    let maxYear = year + 14;

    for (let i = year; i < maxYear; i++) {
      let label = i + "";
      let value = label.substr(2, 2);
      years.push({ label, value });
    }

    this.years = years;

    if (Object.keys(this.products).length) {
      this.fund.product = Object.keys(this.products)[0];
    }
    let prds = JSON.parse(JSON.stringify(this.productsOriginal));

    this.products = prds.map((x) => {
      x.qty = 0;
      return x;
    });
  },
};
</script>

<style></style>
